import React from 'react';

import { SubHeading } from '../../components';
import { images } from '../../constants';
import './Header.css';

const Header = () => (
  <div className='app__header app__wrapper section__padding' id='home'>
    <div className='app__wrapper_info'>
      <SubHeading title='A Culinary Journey Awaits' />
      <h1 className='app__header-h1'>Elevate Your Dining Experience</h1>
      <p className='p__opensans' style={{ margin: '2rem 0' }}>
        Indulge in a symphony of flavors crafted to perfection. Experience the
        finest ingredients, masterful techniques, and an ambiance that
        transforms every meal into an unforgettable moment.
      </p>
      <button type='button' className='custom__button'>
        View Our Menu
      </button>
    </div>

    <div className='app__wrapper_img'>
      <img src={images.welcome} alt='Fine Dining Experience' />
    </div>
  </div>
);

export default Header;
